<div class="container-fluid plyca-header-group-errors m-b-md " *ngIf="!hidden">
  <div class="row">
    <div *ngIf="!hidden && displayShowButton && errorGroup.numberOfErrors() > 0 "
      class="col-12 justify-content-end d-flex">

    </div>
  </div>

  <div class="row">
    <div *ngIf="!hidden && errorGroup?.numberOfListOfErrors([ERRORTYPE.FATAL, ERRORTYPE.ERROR])>0"
      class="leyenda col-12 col-lg-4 d-flex">
      {{errorGroup?.numberOfErrors(ERRORTYPE.FATAL) + errorGroup?.numberOfErrors(ERRORTYPE.ERROR)}}&nbsp;
      <span class="group-fatal">{{'Forms.errors' | translate}}</span>

    </div>

    <div *ngIf="!hidden && errorGroup?.numberOfErrors(ERRORTYPE.WARNING)>0" class="leyenda col-12 col-lg-4">

      {{errorGroup?.numberOfErrors(ERRORTYPE.WARNING)}}&nbsp;
      <span class="group-info">{{'Forms.warns' | translate}}</span>

    </div>

    <!-- <div *ngIf="!hidden && errorGroup?.numberOfErrors(ERRORTYPE.WARNING)>0" class="leyenda col-12 col-lg-4">

      {{errorGroup?.numberOfErrors(ERRORTYPE.WARNING)}}&nbsp;
      <span class="group-info">{{'Forms.warns' | translate}}</span>

    </div> -->

  </div>
</div>